import React from 'react';
import classNames from 'classnames';
import Modal from 'components/shared/Modal/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './DeleteVersionModal.module.css';

const DeleteVersionModal = ({ onClose, onClick, failed, pending, title }) => {
  return (
    <Modal closeTargetRef={null} close={onClose} animate={false} animateX={false} opaque={true} height={200}>
      <div className={styles.root}>
        {!failed ? (
          <div>
            <div className={styles.headerDiv}>
              <div className={styles.title}>{title}</div>
            </div>
            <div className={styles.buttonContainer}>
              <button
                className={classNames({
                  Global_RoundedButton: true,
                  [styles.cancelBtn]: true
                })}
                disabled={pending}
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                className={classNames({
                  Global_RoundedButton: true,
                  [styles.confirmBtn]: true
                })}
                disabled={pending}
                onClick={onClick}
              >
                {pending ? <FontAwesomeIcon className={styles.spinner} icon="spinner" pulse /> : 'Confirm'}
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.errorContainer}>
            <div className={styles.errorHeader}>Error</div>
            <div className={styles.errorMessage}>
              An error occurred while attempting to delete the software. If this problem persists, contact support at
              <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
            </div>
            <button className={styles.errorBtn} onClick={onClose}>
              OK
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DeleteVersionModal;
